import React from 'react';
import { motion } from 'framer-motion';
import { NotebookMockup } from './illustrations/NotebookMockup';
import { Gift, Star, BookOpen, Sparkles } from 'lucide-react';
const modules = ['Trazos y motricidad fina.', 'Letras mayúsculas.', 'Letras minúsculas.', 'Palabras y vocabulario.', 'Escritura práctica y divertida.'];
const bonuses = ['Actividades extra.', 'Juegos educativos.', 'Frases positivas.', 'Laberintos.', 'Une los puntos.', 'Desafíos de escritura.'];
const pluses = ['Guía para mamás.', 'Guía para docentes.', 'Sistema de recompensas.'];
export function IncludesSection() {
  return <section id="que-incluye" className="py-24 bg-white" data-id="element-153">
      <div className="container mx-auto px-6 max-w-6xl" data-id="element-154">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-155">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-800 mb-4" data-id="element-156">
            Todo lo que recibís hoy
          </h2>
          <div className="w-24 h-1.5 bg-pastel-lilac mx-auto rounded-full" data-id="element-157"></div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12" data-id="element-158">
          {/* 5 Módulos */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-pastel-blueLight/40 rounded-3xl p-8 border border-pastel-blueLight relative overflow-hidden" data-id="element-159">
            <div className="flex items-center gap-4 mb-8" data-id="element-160">
              <div className="w-14 h-14 bg-pastel-blue rounded-2xl flex items-center justify-center text-white shadow-sm" data-id="element-161">
                <BookOpen className="w-8 h-8" data-id="element-162" />
              </div>
              <h3 className="text-2xl font-bold text-slate-800" data-id="element-163">5 MÓDULOS</h3>
            </div>

            <div className="grid grid-cols-2 gap-6" data-id="element-164">
              <div className="flex flex-col gap-4" data-id="element-165">
                {modules.map((item, i) => <div key={i} className="flex items-start gap-2" data-id="element-166">
                    <div className="w-2 h-2 rounded-full bg-pastel-blue mt-2 shrink-0" data-id="element-167" />
                    <span className="text-slate-700 font-medium" data-id="element-168">{item}</span>
                  </div>)}
              </div>
              <div className="relative" data-id="element-169">
                <NotebookMockup color="blue" title="Módulos" data-id="element-170" />
              </div>
            </div>
          </motion.div>

          {/* 6 Bonus */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="bg-pastel-mintLight/40 rounded-3xl p-8 border border-pastel-mintLight relative overflow-hidden" data-id="element-171">
            <div className="flex items-center gap-4 mb-8" data-id="element-172">
              <div className="w-14 h-14 bg-pastel-mint rounded-2xl flex items-center justify-center text-white shadow-sm" data-id="element-173">
                <Star className="w-8 h-8" data-id="element-174" />
              </div>
              <h3 className="text-2xl font-bold text-slate-800" data-id="element-175">6 BONUS</h3>
            </div>

            <div className="grid grid-cols-2 gap-6" data-id="element-176">
              <div className="flex flex-col gap-4" data-id="element-177">
                {bonuses.map((item, i) => <div key={i} className="flex items-start gap-2" data-id="element-178">
                    <div className="w-2 h-2 rounded-full bg-pastel-mint mt-2 shrink-0" data-id="element-179" />
                    <span className="text-slate-700 font-medium" data-id="element-180">{item}</span>
                  </div>)}
              </div>
              <div className="relative" data-id="element-181">
                <NotebookMockup color="mint" title="Bonus" data-id="element-182" />
              </div>
            </div>
          </motion.div>

          {/* 3 Plus */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="bg-pastel-yellowLight/40 rounded-3xl p-8 border border-pastel-yellowLight relative overflow-hidden" data-id="element-183">
            <div className="flex items-center gap-4 mb-8" data-id="element-184">
              <div className="w-14 h-14 bg-pastel-yellow rounded-2xl flex items-center justify-center text-slate-800 shadow-sm" data-id="element-185">
                <Sparkles className="w-8 h-8" data-id="element-186" />
              </div>
              <h3 className="text-2xl font-bold text-slate-800" data-id="element-187">3 PLUS</h3>
            </div>

            <div className="grid grid-cols-2 gap-6" data-id="element-188">
              <div className="flex flex-col gap-4" data-id="element-189">
                {pluses.map((item, i) => <div key={i} className="flex items-start gap-2" data-id="element-190">
                    <div className="w-2 h-2 rounded-full bg-pastel-yellow mt-2 shrink-0" data-id="element-191" />
                    <span className="text-slate-700 font-medium" data-id="element-192">{item}</span>
                  </div>)}
              </div>
              <div className="relative" data-id="element-193">
                <NotebookMockup color="yellow" title="Guías" data-id="element-194" />
              </div>
            </div>
          </motion.div>

          {/* Bonus Especial */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.3
        }} className="bg-pastel-lilacLight/40 rounded-3xl p-8 border border-pastel-lilacLight relative overflow-hidden flex flex-col justify-center" data-id="element-195">
            <div className="absolute -right-10 -top-10 text-9xl opacity-10" data-id="element-196">
              🎁
            </div>
            <div className="flex items-center gap-4 mb-6" data-id="element-197">
              <div className="w-14 h-14 bg-pastel-lilac rounded-2xl flex items-center justify-center text-white shadow-sm" data-id="element-198">
                <Gift className="w-8 h-8" data-id="element-199" />
              </div>
              <h3 className="text-2xl font-bold text-slate-800" data-id="element-200">
                BONUS ESPECIAL
              </h3>
            </div>

            <div className="bg-white p-6 rounded-2xl shadow-sm border border-slate-100 flex items-center gap-4" data-id="element-201">
              <span className="text-4xl" data-id="element-202">🎁</span>
              <p className="text-xl font-bold text-slate-700" data-id="element-203">
                Plantillas imprimibles de caligrafía.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}